export const TRADING_PARTNERS_SECTIONS = [
  "purchasers",
  "purchaser-distribution-centers",
] as const;

export type TradingPartnersSection = (typeof TRADING_PARTNERS_SECTIONS)[number];

export function isTradingPartnersSection(
  value: string | undefined,
): value is TradingPartnersSection {
  return (
    typeof value === "string" &&
    (TRADING_PARTNERS_SECTIONS as readonly string[]).includes(value)
  );
}
